import { render, staticRenderFns } from "./OrderFinished.vue?vue&type=template&id=05c59368"
import script from "./OrderFinished.vue?vue&type=script&lang=js"
export * from "./OrderFinished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports